import clsx from 'clsx'
import React, {memo, useCallback, useRef} from 'react'

import {ChevronIcon} from '../icons'
import * as classes from './classes'
import {useAccordion} from './hooks'
import {SummaryProps} from './types'

const AccordionSummary = memo<SummaryProps>(({'data-testid': dataTestId, children, className, id, lead}) => {
  const pressStartRef = useRef<number>()
  const {isExpanded, toggle, expandBy} = useAccordion()

  const handlePressStart = useCallback(() => {
    pressStartRef.current = Date.now()
  }, [])

  const handlePressEnd = useCallback(() => {
    if (pressStartRef.current && Date.now() - pressStartRef.current < 300) {
      toggle()
    }
    pressStartRef.current = undefined
  }, [toggle])

  return (
    <header
      id={id}
      className={clsx(classes.summaryRoot, className, {[classes.summaryRootExpander]: expandBy === 'summary'})}
      onPointerDown={expandBy === 'summary' ? handlePressStart : undefined}
      onPointerUp={expandBy === 'summary' ? handlePressEnd : undefined}
      data-testid={dataTestId}
    >
      <div className={classes.summaryLead}>{lead}</div>
      <div>{children}</div>
      <nav className={classes.summaryNavigation}>
        <button
          className={clsx(classes.summaryNavigationButton, {
            [classes.summaryNavigationButtonExpander]: expandBy === 'expandIcon',
          })}
          onPointerDown={expandBy === 'expandIcon' ? handlePressStart : undefined}
          onPointerUp={expandBy === 'expandIcon' ? handlePressEnd : undefined}
          type="button"
        >
          <ChevronIcon className={clsx(classes.summaryTrailIcon, {[classes.summaryExpandedTrailIcon]: isExpanded})} />
        </button>
      </nav>
    </header>
  )
})

AccordionSummary.displayName = 'AccordionSummary'

export {AccordionSummary}
